import { render, staticRenderFns } from "./ProductIntroIndex.vue?vue&type=template&id=9e268e18&scoped=true&"
import script from "./ProductIntroIndex.vue?vue&type=script&lang=ts&"
export * from "./ProductIntroIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ProductIntroIndex.vue?vue&type=style&index=0&id=9e268e18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e268e18",
  null
  
)

export default component.exports